module.exports = __webpack_public_path__ + "img/13.b8410e9c.png";